module.exports = __webpack_public_path__ + "static/media/return.5cc2b0d1.svg";